const translations = {
  "en": {
    "months": "months"
  },
  "zh-tw": {
    "months": "個月"
  }
};

export default translations;
